module.exports = __webpack_public_path__ + "assets/img/gyg_img.82bc4626.png";